






























import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class PartnersSection extends Vue {
  numLogos: number = 5;
  mySwiper: any = {};
  swiperResizeHandler: any = Vue.prototype.$_.debounce(this.swiperUpdate, 2000);
  swiperOptions: any = {
    direction: "horizontal",
    loop: true,
    loopedSlides: this.numLogos,
    loopAdditionalSlides: this.numLogos * 2,
    sliderPerView: "auto",
    spaceBetween: 20,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    speed: 10000,
    freeMode: true,
    freeModeMomentumBounce: false,
    // breakpoints: {
    //   768: {
    //     direction: "vertical",
    //   }
    // },
  }

  swiperUpdate() {
    this.mySwiper.destroy(false, true);

    var isVerticalLayout = Vue.prototype.common.isVerticalLayout()
    if (isVerticalLayout) {
      this.swiperOptions.direction = "horizontal";
    } else {
      this.swiperOptions.direction = "vertical";
    }
    this.mySwiper = new Swiper (".swiper-container", this.swiperOptions);
  }

  mounted() {
    var isVerticalLayout = Vue.prototype.common.isVerticalLayout()
    if (isVerticalLayout) {
      this.swiperOptions.direction = "horizontal";
    } else {
      this.swiperOptions.direction = "vertical";
    }
    this.mySwiper = new Swiper (".swiper-container", this.swiperOptions);

    window.addEventListener('resize', this.swiperResizeHandler);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.swiperResizeHandler);
    this.mySwiper.destroy(true, true);
  }
}
